var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-slider-box -lightness-slider"},[_c('span',[_vm._v("Lightness")]),_vm._v(" "),_c('div',{staticClass:"-swatch"},_vm._l((_vm.swatchParts),function(part,i){return _c('div',{key:i,staticClass:"-handle",class:{
        '-active': _vm.activePart === part.value,
      },style:({ background: part.background }),on:{"click":function($event){return _vm.setNewHsl(part.fValue)}}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }